module.exports = __webpack_public_path__ + "static/img/third2_1_5.99514625.jpg";